<template>
  <v-tooltip
    top
    :disabled="!tooltip"
  >
    <template #activator="{ on, attrs }">
      <v-avatar
        v-bind="attrs"
        :size="size"
        :color="profile.avatarUrl ? 'transparent' : 'grey'"
        :class="`${cssClass || ''} font-weight-bold border border-white ${textSize}`"
        v-on="on"
      >
        <img
          v-if="profile.avatarUrl"
          :src="profile.avatarUrl"
          :alt="profile.fullName"
        />
        <template v-else>
          {{
            (profile.fullName || profile.email || ' ')
              .split(' ')
              .map((x) => (x[0] || '').toUpperCase())
              .join('')
              .slice(0, 2)
          }}
        </template>
      </v-avatar>
    </template>
    <div>{{ profile.fullName || profile.email }}</div>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    size: { type: Number, default: 70 },
    textSize: { type: String, default: 'text-h4' },
    profile: { type: Object, default: () => {} },
    cssClass: {
      type: String,
      default: ''
    },
    tooltip: { type: Boolean, default: false }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({})
  },
  methods: {}
};
</script>
